/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Hint_No_ChannelInputs */

const en_sorx_hint_no_channel = /** @type {(inputs: Sorx_Hint_No_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an email, Telegram or Discord channel below so team updates reach you.`)
};

const id_sorx_hint_no_channel = /** @type {(inputs: Sorx_Hint_No_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan email, Telegram, atau Discord di bawah agar kabar tim sampai ke Anda.`)
};

/**
* | output |
* | --- |
* | "Add an email, Telegram or Discord channel below so team updates reach you." |
*
* @param {Sorx_Hint_No_ChannelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_hint_no_channel = /** @type {((inputs?: Sorx_Hint_No_ChannelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Hint_No_ChannelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_hint_no_channel(inputs)
	return en_sorx_hint_no_channel(inputs)
});